import React, {useEffect, VoidFunctionComponent} from 'react';
import ReactDom from 'react-dom';
import {useIntl} from 'react-intl';

import styles from './modal.module.css';

const ModalRoot = document.querySelector('#modal-root');

type Props = {message: string; onClose: () => void};

const Modal: VoidFunctionComponent<Props> = ({message, onClose}: Props) => {
  const intl = useIntl();

  useEffect(() => {
    ModalRoot?.classList.add('active');
    return () => ModalRoot?.classList.remove('active');
  }, []);

  if (!ModalRoot) {
    return null;
  }

  return ReactDom.createPortal(
    <div className={styles.container}>
      <div className={styles.message}>{message}</div>
      <button className="button-primary" onClick={onClose}>
        {intl.formatMessage({id: 'ok'})}
      </button>
    </div>,
    ModalRoot
  );
};

export default Modal;
